import React from 'react'

import { Player } from 'video-react'

import {
    EuiText,
    EuiIcon,
    EuiPanel
  } from '@elastic/eui'

import { OutboundLink } from 'gatsby-plugin-gtag'

require('../../../Layout/chrome/assets/video.css')

function VideoCard() {
  return (
    <EuiPanel paddingSize="m">
        <Player>
            <source src="https://wiki.instar.com/videos/Mikrofon_oder_PIR_Sensor_deaktivieren_IN9008FullHD.mp4" />
        </Player>
        <EuiText>
            <p>Mikrofon oder PIR Sensor deaktivieren IN-9008FullHD. Auf <OutboundLink href="https://www.youtube.com/watch?v=WwSciz3Fhc8" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
        </EuiText>
    </EuiPanel>
  );
}

export default VideoCard